import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HeaderService } from '../core/services/header.service';
import { Subscription } from 'rxjs';
import { slideInAnimation } from '../core/animations/router.animations';
import { RouterOutlet } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatDrawerMode, MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { NgIf, NgClass } from '@angular/common';
import { MainNavComponent } from './navigation/main-nav.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { HeaderComponent } from './header/header.component';
import { FlexModule } from '@angular/flex-layout';
import { GlobalNotificationsComponent } from './global-notification/global-notifications.component';

@Component({
  selector: 'app-cpn',
  templateUrl: './cp.component.html',
  styleUrls: ['./cp.component.scss'],
  animations: [slideInAnimation],
  standalone: true,
  imports: [
    MatSidenavContainer,
    NgIf,
    MatSidenav,
    MainNavComponent,
    MatSidenavContent,
    SideMenuComponent,
    HeaderComponent,
    NgClass,
    FlexModule,
    GlobalNotificationsComponent,
    RouterOutlet,
  ],
})
export class CpComponent implements OnInit, OnDestroy {
  @ViewChild('secondNav') secondNav: MatSidenav;
  mobileViewSubscription: Subscription;
  wrapperHeight = 'calc(100vh - 94px)';
  currentYear: number;
  sidenavMode: MatDrawerMode = 'side';
  mobileQuery: MediaQueryList;
  private readonly mobileQueryListener: () => void;

  isMobileView = false;

  constructor(
    public headerService: HeaderService,
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
  ) {
    this.mobileQuery = this.media.matchMedia('(max-width: 820px)');
    this.mobileQueryListener = () => {
      this.changeDetectorRef.detectChanges();
      this.headerService.updateIsMobileView(this.mobileQuery.matches);
    };
    this.mobileQuery.addEventListener('change', this.mobileQueryListener);
    this.headerService.updateIsMobileView(this.mobileQuery.matches);
  }

  getAnimationData(outlet: RouterOutlet) {
    // return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
    return outlet.isActivated ? outlet.activatedRoute : '';
  }

  ngOnInit() {
    this.wrapperHeight = this.headerService.isMobileAppView
      ? '100vh'
      : this.headerService.isMobileView.getValue() && this.headerService.isShowingSearch
        ? 'calc(100vh - 135px)'
        : 'calc(100vh - 94px)';

    this.mobileViewSubscription = this.headerService.isMobileView.subscribe(value => {
      this.isMobileView = value;
      if (this.headerService.isMobileAppView) {
        this.wrapperHeight = '100vh';
      } else if (value && this.headerService.isShowingSearch) {
        this.wrapperHeight = value && this.headerService.isShowingSearch ? 'calc(100vh - 135px)' : 'calc(100vh - 94px)';
      } else if (value && !this.headerService.isShowingSearch) {
        this.wrapperHeight = 'calc(100vh - 106px)';
      } else {
        this.wrapperHeight = 'calc(100vh - 94px)';
      }
    });

    this.currentYear = new Date().getFullYear();

    this.headerService.isMobileView.subscribe(isMobile => {
      this.sidenavMode = isMobile ? 'over' : 'side';
    });
  }

  ngOnDestroy() {
    this.mobileViewSubscription?.unsubscribe();
    this.mobileQuery.removeEventListener('change', this.mobileQueryListener);
  }
}
